// extracted by mini-css-extract-plugin
export var label = "statTile-module--label--ac037";
export var number = "statTile-module--number--1f933";
export var tile = "statTile-module--tile--b3a48";
export var tileDisabled = "statTile-module--tile-disabled--0e7ca";